var progressBar = {
    base: {
        position: "relative",
        boxSizing: "border-box",
        minWidth: "auto",
        height: 1,
        borderRadius: 2,
        backgroundColor: "black.10",
        color: "primary.100",
        width: "100%",
    },
};
var progressBarValue = {
    base: {
        minWidth: "auto",
        color: "black.60",
        display: "flex",
        font: "body",
        justifyContent: "flex-end",
    },
};

export { progressBar, progressBarValue };
//# sourceMappingURL=progress-bar.js.map
